<!--
 * @Author: chenhongwei chenhw2019@gmail.com
 * @Date: 2023-04-13 20:33:59
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-20 18:07:35
 * @FilePath: /seller.sviptrader.com/src/components/baseUI/rdStatus/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="status-wrapper font-h6-regular">
		<i :class="['round', type]"></i>
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			default: 'success',
		},
	},
};
</script>
<style lang="less" scoped>
.status-wrapper {
	display: flex;
	align-items: center;
	font-family: PingFang SC;
	/* Font/text-primary */
	color: @color-gy9;
	.round {
		display: inline-block;
		width: 6px;
		height: 6px;
		border-radius: 50%;
		margin-right: 6px;
	}
	.success {
		background: #0fb820;
	}
	.error {
		background: #fa2714;
	}
	.primary {
		background: #7052ff;
	}
	.fail {
		background: #86909d;
	}
	.warning {
		background: #ff7038;
	}
}
</style>